import { Routes } from '@angular/router';
import { authGuardFn } from './common/guards/auth.guard';
import { createRoleGaurd } from './common/guards/role.guard';
import { adminGuard } from './common/guards/admin.guard';
import { experimentalGuard } from './common/guards/experimental.guard';

export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./auth/pages/login/login.component').then(m => m.LoginComponent),
  },
  {
    path: 'session-expired',
    loadComponent: () => import('./auth/pages/session-expired/session-expired.component').then(m => m.SessionExpiredComponent),
  },
  {
    path: 'help/rule-properties',
    loadComponent: () => import('./help/pages/rule-properties-help/rule-properties-help.component').then(m => m.RulePropertiesHelpComponent),
    canActivate: [authGuardFn]
  },
  {
    path: 'devices',
    loadComponent: () => import('./devices/pages/devices/devices.component').then(m => m.DevicesComponent),
    canActivate: [authGuardFn]
  },
  {
    path: 'health',
    loadComponent: () => import('./health/pages/health/health.component').then(m => m.HealthComponent),
    canActivate: [authGuardFn, createRoleGaurd('VIEW_CAMERA')]
  },
  {
    path: 'sites',
    loadComponent: () => import('./sites/pages/site-list/site-list.component').then(m => m.SiteListComponent),
    canActivate: [authGuardFn, createRoleGaurd('VIEW_SITE')]
  },
  {
    path: 'sites/dashboard',
    loadComponent: () => import('./sites/pages/details/details.component').then(m => m.DetailsComponent),
    canActivate: [authGuardFn, createRoleGaurd('VIEW_SITE', 'VIEW_CAMERA')]
  },
  {
    path: 'sites/camera',
    loadComponent: () => import('./sites/pages/sensor-details/sensor-details.component').then(m => m.SensorDetailsComponent),
    canActivate: [authGuardFn, createRoleGaurd('VIEW_SITE', 'VIEW_CAMERA')]
  },
  {
    path: 'rule-templates',
    loadComponent: () => import('./rule-templates/pages/rule-template-list/rule-template-list.component').then(m => m.RuleTemplatesListComponent),
  },
  {
    path: 'alert-report-templates',
    loadComponent: () => import('./alert-report-templates/pages/report-template-list/report-template-list.component').then(m => m.ReportTemplateListComponent),
    canActivate: [authGuardFn, adminGuard]
  },
  {
    path: 'users',
    loadComponent: () => import('./account-management/pages/user-list/user-list.component').then(m => m.UserListComponent),
    canActivate: [authGuardFn, adminGuard]
  },
  {
    path: 'customers/users',
    loadComponent: () => import('./account-management/pages/user-list/user-list.component').then(m => m.UserListComponent),
    canActivate: [authGuardFn, adminGuard]
  },
  {
    path: 'customers',
    loadComponent: () => import('./account-management/pages/customer-list/customer-list.component').then(m => m.CustomerListComponent),
    canActivate: [authGuardFn, adminGuard]
  },
  {
    path: 'subscriptions',
    loadComponent: () => import('./account-management/pages/subscription-list/subscription-list.component').then(m => m.SubscriptionListComponent),
    canActivate: [authGuardFn, adminGuard]
  },
  {
    path: 'integrations',
    loadComponent: () => import('./integrations/pages/integration-list/integration-list.component').then(m => m.IntegrationListComponent),
    canActivate: [authGuardFn, adminGuard]
  },
  {
    path: 'livefeed',
    loadComponent: () => import('./livefeed/pages/livefeed/livefeed.component').then(m => m.LivefeedComponent),
    canActivate: [authGuardFn, createRoleGaurd('VIEW_SITE', 'VIEW_CAMERA')]
  },
  {
    path: 'alerts',
    loadComponent: () => import('./alert-dashboard/pages/alert-dashboard/alert-dashboard.component').then(m => m.AlertDashboardComponent),
    canActivate: [authGuardFn, createRoleGaurd('VIEW_SITE', 'VIEW_CAMERA')]
  },
  {
    path: 'focus',
    loadComponent: () => import('./focus-mode/pages/focus-mode/focus-mode.component').then(m => m.FocusModeComponent),
    canActivate: [authGuardFn, createRoleGaurd('VIEW_SITE', 'VIEW_CAMERA')]
  },
  {
    path: 'reports',
    loadComponent: () => import('./reports/pages/report-list/report-list.component').then(m => m.ReportListComponent),
    canActivate: [authGuardFn, adminGuard]
  },
  {
    path: 'recordings',
    loadComponent: () => import('./recordings/pages/recordings.component').then(m => m.RecordingsComponent),
    canActivate: [authGuardFn, createRoleGaurd('VIEW_SITE', 'VIEW_CAMERA')]
  },
  {
    path: 'vms',
    loadComponent: () => import('./vms/pages/vms.component').then(m => m.VmsComponent),
    canActivate: [authGuardFn, createRoleGaurd('VIEW_SITE', 'VIEW_CAMERA')]
  },
  {
    path: 'recipients',
    loadComponent: () => import('./account-management/pages/recipient-list/recipient-list.component').then(m => m.RecipientListComponent),
    canActivate: [authGuardFn, createRoleGaurd('GET_COMMS_RECIPIENT')]
  },
  {
    path: 'tags',
    loadComponent: () => import('./tags/pages/tag-list/tag-list.component').then(m => m.TagListComponent),
    canActivate: [authGuardFn, adminGuard]
  },
  {
    path: 'patrol-templates',
    loadComponent: () => import('./patrol/pages/template-list/template-list.component').then(m => m.PatrolTemplateListComponent),
    canActivate: [authGuardFn, adminGuard]
  },
  {
    path: 'patrol-schedules',
    loadComponent: () => import('./patrol/pages/schedule-list/schedule-list.component').then(m => m.PatrolScheduleListComponent),
    canActivate: [authGuardFn, adminGuard]
  },
  {
    path: 'rule-schedules',
    loadComponent: () => import('./rule-schedules/pages/rule-schedule-list/rule-schedule-list.component').then(m => m.RuleScheduleListComponent),
    canActivate: [authGuardFn, adminGuard]
  },

  {
    path: 'patrol-findings',
    loadComponent: () => import('./patrol/pages/finding-list/finding-list.component').then(m => m.PatrolFindingListComponent),
    canActivate: [authGuardFn, adminGuard]
  },
  {
    path: 'patrol-runs',
    loadComponent: () => import('./patrol/pages/run-list/run-list.component').then(m => m.PatrolRunListComponent),
    canActivate: [authGuardFn, adminGuard]
  },
  {
    path: 'patrol-runs/:runId',
    loadComponent: () => import('./patrol/pages/run-detail/run-detail.component').then(m => m.PatrolRunDetailComponent),
    canActivate: [authGuardFn, adminGuard]
  },

  {
    path: 'feature-management',
    loadComponent: () => import('./compute-credit-management/pages/feature-management/feature-management.component').then(m => m.FeatureManagementComponent),
    canActivate: [authGuardFn, adminGuard]
  },

  {
    path: 'subscriptions-plus',
    loadComponent: () => import('./subscriptions-plus/pages/license-list/license-list.component').then(m => m.LicenseListComponent),
    canActivate: [authGuardFn, adminGuard]
  },
  {
    path: 'spotlyte',
    loadComponent: () => import('./spotlyte/pages/job-list/job-list.component').then(m => m.SpotlyteJobListComponent),
    canActivate: [authGuardFn, adminGuard],
  },
  {
    path: 'spotlyte/sources',
    loadComponent: () => import('./spotlyte/pages/source-library/source-library.component').then(m => m.SpotlyteSourceLibraryComponent),
    canActivate: [authGuardFn, adminGuard],
  },
  {
    path: 'spotlyte/jobs/:id',
    loadComponent: () => import('./spotlyte/pages/job-detail/job-detail.component').then(m => m.SpotlyteJobDetailComponent),
    canActivate: [authGuardFn, adminGuard],
  },
  {
    path: 'registries',
    loadComponent: () => import('./registries/pages/registry-list/registry-list.component').then(m => m.RegistryListComponent),
    canActivate: [authGuardFn, adminGuard, experimentalGuard],
  },
  {
    path: 'registries/detail',
    loadComponent: () => import('./registries/pages/registry-detail/registry-detail.component').then(m => m.RegistryDetailComponent),
    canActivate: [authGuardFn, adminGuard, experimentalGuard],
  },
  { path: '**', loadComponent: () => import('./common/pages/not-found/not-found.component').then(m => m.NotFoundComponent) }
];
